import { format, isSameYear } from 'date-fns';
import de from 'date-fns/locale/de';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';

import Text from '@/components/Text';
import { useAccordionCtx } from '@/context/Accordion';
import { useProjectDetailsContext } from '@/context/ProjectDetails';
import { formatTime } from '@/utils';

const Appointment = ({ data, today }) => {
  const currDate = format(new Date(data.date), 'yyyy-MM-dd');
  const hasSameYear = isSameYear(new Date(data.date), new Date());
  const { setValue } = useAccordionCtx();
  const { showTask } = useProjectDetailsContext();
  const router = useRouter();

  const handleAccordion = async ({ subtask, task, task_id: taskId, project_id: pid }) => {
    if (router.pathname === '/projekte' || router.pathname === '/dashboard') {
      await router.push({
        pathname: `/projekte/${pid}`,
        query: {
          ...(taskId ? { taskId } : {}),
          ...(subtask ? { subtaskId: subtask } : {}),
        },
      });
    } else {
      if (subtask) {
        setValue(`${taskId}`);
        showTask(pid, `${taskId}`, subtask);
      }

      if (task) {
        setValue(task);
      }
    }
  };

  return (
    <Box key={data.id} my={3} sx={{ cursor: 'pointer' }} onClick={() => handleAccordion(data)}>
      <Text variant="calendarHasDate">
        {format(new Date(data.date), 'd. MMMM', { locale: de })} {!hasSameYear && format(new Date(data.date), 'yyy')}
      </Text>
      <Box
        px={12}
        py={12}
        mt={2}
        sx={{
          border: today === currDate ? 'none' : '1px solid #ebebeb',
          borderRadius: today === currDate ? 'none' : '4px',
          borderLeft: today === currDate ? '3px solid #52b292' : '1px solid #ebebeb',
        }}
      >
        <Flex justifyContent="space-between">
          <Text variant="calendarEntry" width="70%">
            {data.title}
          </Text>
          {data.time && <Text variant="calendarEntry">{formatTime(data.time)} Uhr</Text>}
        </Flex>
      </Box>
    </Box>
  );
};

Appointment.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    subtask: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  today: PropTypes.string.isRequired,
};

export default Appointment;
